<div style="margin-top: 12%; font-size: 30px;">
Welcome to Campus buddy.
</div>